import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/scripts/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuOpen: false,
    news: {
      firstItems: [],
      lastItems: [],
    },
    formStatus: null,
  },
  mutations: {
    TOGGLE_MENU(state) {
      state.menuOpen = !state.menuOpen;
    },
    SET_MENU(state, bool) {
      state.menuOpen = bool;
    },
    SET_NEWS(state, array) {
      state.news.firstItems = array.slice(0, 5);
      state.news.lastItems = array.slice(5);
    },
    FORM_STATUS(state, payload) {
      state.formStatus = payload;
    },
  },
  getters: {
    getNews(state) {
      return state.news;
    },
    getCurrrentPost(state) {
      const path = `/${state.route.params.post}/`;
      let index = state.news.firstItems.findIndex(item => item.path === path);
      let post;

      if (index > -1) {
        post = state.news.firstItems[index];
      } else {
        index = state.news.lastItems.findIndex(item => item.path === path);

        post = index > -1 ? state.news.lastItems[index] : undefined;
      }

      return post;
    },
    getFormStatus: state => state.formStatus,
  },
  actions: {
    async SEND_FORM({ commit }, form) {
      const url = 'https://us-central1-moonshot-website.cloudfunctions.net/sendMail';

      await fetch(url, {
        method: 'POST',
        body: JSON.stringify(form),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json()
        .then((data) => {
          if (data.status) commit('FORM_STATUS', 'sent');
        }));
    },
    async FETCH_NEWS({ commit }) {
      return api.fetchArchive('post', ['image', 'intro'], {
        start: 0,
        count: 9999,
      }).then((res) => {
        commit('SET_NEWS', res.archive.items);
      });
    },
  },
});
